import { UploadImageCard } from "components/UploadImageCard"
import { type UICustomizationData } from "pages/UICustomization/types.ts"
import { useTranslation } from "react-i18next"
import { Info } from "lucide-react"

interface UICustomizationLogoProps {
  data: UICustomizationData
  onChange: (data: UICustomizationData) => void
}

const logosTemplate = (t: (key: string) => string) => [
  {
    title: t("uiCustomizationLogo.mainLogo"),
    key: "main",
    widthToHeightRatio: 4,
  },
  {
    title: t("uiCustomizationLogo.shortLogo"),
    key: "short",
    widthToHeightRatio: 1,
  },
]

type LogoKey = "main" | "short"

export const UICustomizationLogo = ({ data, onChange }: UICustomizationLogoProps) => {
  const { t } = useTranslation()
  const template = logosTemplate(t)

  return (
    <div className="space-y-3">
      {/* Guidelines */}
      <div className="flex items-start gap-3 rounded-lg border bg-muted/30 p-4">
        <Info className="mt-0.5 size-4 shrink-0 text-muted-foreground" />
        <p className="whitespace-pre-line text-sm leading-relaxed text-muted-foreground">
          {t("uiCustomizationLogo.description")}
        </p>
      </div>

      {/* Upload cards */}
      <div className="grid grid-cols-2 gap-6">
        {template.map(({ title, key, widthToHeightRatio }) => (
          <UploadImageCard
            key={key}
            title={title}
            widthToHeightRatio={widthToHeightRatio}
            src={data.logos[key as LogoKey]}
            onChange={(imageSrc, base64) =>
              onChange({
                ...data,
                logos: {
                  ...data.logos,
                  [key]: imageSrc || undefined,
                  [`${key}Base64`]: base64,
                },
              })
            }
          />
        ))}
      </div>
    </div>
  )
}
